import GroupPermissionService from '@/service/group-permission'
import PermissionService from '@/service/permission'

export default {
  getAllPermission ({commit}, payload) {
    return new Promise((resolve, reject) => {
      PermissionService.getPermission().then(res => {
        commit('setAllPermission', res.data)
        resolve(res)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  addPermission ({commit}, payload) {
    return new Promise((resolve, reject) => {
      PermissionService.createPerm(payload.permission).then(res => {
        commit('addPermission', res.data)
        resolve(res)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  addGrpPermission ({commit}, payload) {
    return new Promise((resolve, reject) => {
      PermissionService.createPerm(payload.permission).then(res => {
        commit('addGrpPermission', res.data)
        resolve(res)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  getPermission ({commit}, payload) {
    return new Promise((resolve, reject) => {
      GroupPermissionService.getPermissionOfGroup(payload.group).then(res => {
        commit('setPermission', res.data.data)
        resolve(res)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  createPermission ({commit}, payload) {
    return new Promise((resolve, reject) => {
      GroupPermissionService.createPermission(payload.group, payload.permissions).then(res => {
        resolve(res)
      }).catch(errors => {
        reject(errors)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/module/group-permission/actions.js